import styled from 'styled-components';

import { Button as Btn } from '../../../components/Button';
import { Row as R } from '../../../components/Common';
import MsgLogo from '../../../components/Logo/Logo';

export const Row = styled(R)`
  justify-content: center;
  padding: 5rem 1rem;
  @media screen and (min-width: 992px) {
    padding: 11vw 26vw 3vw 26vw;
  }
`;

export const Logo = styled(MsgLogo)`
  width: 9.375rem;
  height: auto;
`;

export const Title = styled.h1.attrs({ className: 'pt-4 pb-1 text-center text-uppercase p-5' })`
  font-size: 2rem;
  font-family: 'GothamNarrow';
  font-weight: 900;
  line-height: 2rem;
  @media screen and (min-width: 992px) {
    font-size: calc(20px + 60 * ((100vw - 576px) / 3264));
    font-weight: 900;
    line-height: 4vw;
  }
`;

export const Description = styled.p`
  font-family: 'GothamNarrow';
  font-weight: 325;
  font-size: 1rem;
  color: #eeeeee;
  text-align: center;

  @media screen and (min-width: 992px) {
    font-weight: 325;
    font-size: calc(8px + 24 * ((100vw - 576px) / 3264));
    color: #eeeeee;
  }
`;

export const Button = styled(Btn)`
  max-width: 100%;

  @media screen and (min-width: 992px) {
    font-size: calc(9px + 24 * ((100vw - 992px) / 3264));
    height: calc(26px + 78 * ((100vw - 992px) / 3264));
    width: calc(250px + 750 * ((100vw - 992px) / 3264));
    border-radius: calc(2.5px + 6 * ((100vw - 992px) / 3264));
  }
`;
